import { DropdownItem } from "../../../types/observation";
import { SparcWalkRowData } from "../../../types/sparcWalk";
import { FilterState } from "../SparcWalkTypes";
import { formatUserName } from "../../../utils/emailTouserName";
import { getYearOptions } from "../../../utils/filterOptions";
import { selectCategoryOptions } from "./sparcWalkConstants";

interface FilterOptionsBuilderParams {
  filters: FilterState;
  zoneOptions: DropdownItem[];
  fullSparcWalkData: SparcWalkRowData[];
}

/**
 * Builds filter options for the SPARC Walk screen
 * Generates dropdown options for all filter types including zone, category, created by, etc.
 */
export const buildFilterOptions = ({
  filters,
  zoneOptions,
  fullSparcWalkData,
}: FilterOptionsBuilderParams) => {
  return [
    {
      key: "zone",
      label: "Zone",
      selectedOptionId: filters.zone ? filters.zone.id : "",
      options: zoneOptions,
    },
    {
      key: "category",
      label: "Category",
      selectedOptionId: filters.category ? filters.category.id : "",
      options: selectCategoryOptions,
    },
    {
      key: "Created_By",
      label: "Created By",
      selectedOptionId: filters.Created_By,
      options: Array.from(
        new Set(
          fullSparcWalkData
            .filter((item) => item.Created_By)
            .map((item) => item.Created_By)
        )
      ).map((email) => ({
        id: email,
        displayText: formatUserName(email),
        email: email,
      })),
    },
    {
      key: "Modified_By",
      label: "Finalized By",
      selectedOptionId: filters.Modified_By,
      options: Array.from(
        new Set(
          fullSparcWalkData
            .filter((item) => item.Modified_By && item.modifiedby)
            .map((item) => ({
              email: item.Modified_By,
              name: formatUserName(item.Modified_By),
            }))
            .filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.email === item.email)
            )
        )
      ).map(({ email, name }) => ({
        id: email,
        displayText: name,
        email: email,
      })),
    },
    {
      key: "action",
      label: "Status",
      selectedOptionId: filters.action,
      options: Array.from(
        new Set(fullSparcWalkData.map((item) => item.status).filter(Boolean))
      ).map((status) => ({
        id: status,
        displayText: status,
      })),
    },
    {
      key: "period",
      label: "Period",
      selectedOptionId: filters.period,
      options: Array.from({ length: 12 }, (_, i) => ({
        id: String(i + 1),
        displayText: String(i + 1),
      })),
    },
    {
      key: "week",
      label: "Week",
      selectedOptionId: filters.week,
      options: Array.from({ length: 4 }, (_, i) => ({
        id: String(i + 1),
        displayText: String(i + 1),
      })),
    },
    {
      key: "year",
      label: "Year",
      selectedOptionId: filters.year,
      options: getYearOptions(),
    },
  ];
};
